module.exports = __webpack_public_path__ + "static/hyena-1659fa255501f10a6203ed2783711687.jpg";